<ul data-personalized="true" class="list-group list-group-flush fs-xs text-center">
	{{#each this}}
	<li class="list-group-item bg-transparent p-1">
		<img class="img-fluid" alt="{{{Title}}}" src="{{ImageLink}}" />
		<a class="rcnt-title stretched-link line-clamp-3" href="{{Link}}" data-rr-url="{{RRLink}}">{{{Title}}}</a>
		{{#if HasPriceRange}}
		{{#if IsOnSale}}
		<div class="price price--sale"><span class="visually-hidden">Select sizes on sale. Prices range from&nbsp;</span><span class="low">{{CurrencySymbol}}{{MinPrice}}</span><span class="visually-hidden">&nbsp;to&nbsp;</span><span class="dash">-</span><span class="high">{{CurrencySymbol}}{{MaxPrice}}</span></div>
		{{else}}
		<div class="price"><span class="visually-hidden">Prices range from&nbsp;</span><span class="low">{{CurrencySymbol}}{{MinPrice}}</span><span class="visually-hidden">&nbsp;to&nbsp;</span><span class="dash" aria-hidden="true">-</span><span class="high">{{CurrencySymbol}}{{MaxPrice}}</span></div>
		{{/if}}
		{{else}}
		{{#if IsOnSale}}
		<div class="price price--sale">{{CurrencySymbol}}{{MaxPrice}}</div>
		{{else}}
		<div class="price">{{CurrencySymbol}}{{MaxPrice}}</div>
		{{/if}}
		{{/if}}
	</li>
	{{/each}}
</ul>